import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'search-icon',
  templateUrl: './search-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchIconComponent {}
